<div class="row">
  <div class="col-12 text-right">
    <button type="button" class="btn btn-primary" (click)="openCreateWarrantyModal()" translate>
      CREATE_NEW
    </button>
  </div>
</div>
<div class="row pt-4">
  <div class="col">
    <lib-return-warranty-list [customerId]="customer.id" [topFilter]="true"></lib-return-warranty-list>
  </div>
</div>
